import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

class ErrorModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: false,
    };
  }

  show(value) {
    this.setState({
      modal: true,
    });
  }

  hide(value) {
    this.setState({
      modal: false,
    });
  }

  render() {
    return (
      <div>
        <Modal isOpen={this.state.modal} toggle={this.hide} className={this.props.className}>
          <ModalHeader>Erreur</ModalHeader>
          <ModalBody>Veuillez corriger les champs en rouge </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => this.hide()}>
              Revenir au formulaire
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default ErrorModal;
